import { CompRef, DocumentServicesObject } from '@wix/document-services-types';
import {
  PluginInstallationParams,
  WidgetPointer,
  PluginsHostApiContext,
} from '@wix/editor-platform-host-integration-apis';
import { ComponentRef } from '@wix/editor-platform-sdk-types';
import { PlatformContext } from '../../../types/platformApi';
import { getHostApi } from './hostAPI/hostAPI';
import { IExperimentsApiAdapter } from '../../utils/experimentsApiAdapter';

// TODO: make autoPopulate logic part of initPluginsService()
async function navigateAsync(
  documentServicesAPI: DocumentServicesObject,
  pageId: string,
) {
  const promisifiedNavigation = new Promise<void>((resolve) => {
    documentServicesAPI.pages.navigateTo(
      pageId,
      () => {
        resolve();
      },
      () => {
        resolve(); // If we couldn't navigate we still want to try to add the plugin
      },
    );
  });
  return promisifiedNavigation;
}

async function addWidgetPlugin(
  context: PlatformContext,
  documentServicesAPI: DocumentServicesObject,
  slotComponentRef: ComponentRef,
  widgetRef: WidgetPointer,
  pluginsHostAPIContext: PluginsHostApiContext,
  experimentsAPI: IExperimentsApiAdapter,
): Promise<CompRef> {
  const hostAPI = getHostApi(documentServicesAPI, experimentsAPI);
  const slotInfo = hostAPI.getWidgetSlot(slotComponentRef);

  if (slotInfo?.pluginInfo !== undefined) {
    await hostAPI.uninstallWidgetPlugin(
      context,
      slotComponentRef,
      pluginsHostAPIContext,
    );
  }

  return hostAPI.installWidgetPlugin(
    context,
    slotComponentRef,
    widgetRef,
    pluginsHostAPIContext,
  );
}

function populate(
  context: PlatformContext,
  documentServicesAPI: DocumentServicesObject,
  pluginInstallationParams: PluginInstallationParams,
  pluginsHostAPIContext: PluginsHostApiContext,
  experimentsAPI: IExperimentsApiAdapter,
): Promise<CompRef> {
  return addWidgetPlugin(
    context,
    documentServicesAPI,
    pluginInstallationParams.slotComponentRef,
    pluginInstallationParams.widgetRef,
    pluginsHostAPIContext,
    experimentsAPI,
  );
}
export async function autoInstall(
  context: PlatformContext,
  documentServicesAPI: DocumentServicesObject,
  pluginInstallationParams: PluginInstallationParams,
  pluginsHostAPIContext: PluginsHostApiContext,
  experimentsAPI: IExperimentsApiAdapter,
): Promise<CompRef | null> {
  const pluginRef = await populate(
    context,
    documentServicesAPI,
    pluginInstallationParams,
    pluginsHostAPIContext,
    experimentsAPI,
  );

  return pluginRef;
}

export async function autoInstallWithNavigation(
  context: PlatformContext,
  documentServicesAPI: DocumentServicesObject,
  pluginInstallationParams: PluginInstallationParams,
  pluginsHostAPIContext: PluginsHostApiContext,
  experimentsAPI: IExperimentsApiAdapter,
): Promise<CompRef | null> {
  await navigateAsync(documentServicesAPI, pluginInstallationParams.pageId);

  await documentServicesAPI.waitForChangesAppliedAsync();

  const pluginRef = await populate(
    context,
    documentServicesAPI,
    pluginInstallationParams,
    pluginsHostAPIContext,
    experimentsAPI,
  );

  await documentServicesAPI.waitForChangesAppliedAsync();

  await (documentServicesAPI.pages as any).scrollToComponent(pluginRef.id); // for some reason type is missing and its actually exists

  context.platformApiMethods.editor.selection.selectComponentByCompRef(
    null,
    '',
    { compsToSelect: [pluginRef] },
  );

  return pluginRef;
}
